export const multipleCheckBoxCheckedHandler = (
  organization,
  setAllOrganization,
  setMultipleSelectData,
  e
) => {
  const { name } = e.target;
  if (name === "allselect") {
    // eslint-disable-next-line no-use-before-define
    pageMultipleSelect(
      organization,
      setAllOrganization,
      setMultipleSelectData,
      e
    );
  } else {
    // eslint-disable-next-line no-use-before-define
    pageSingleSelect(
      organization,
      setAllOrganization,
      setMultipleSelectData,
      e
    );
  }
};

export const pageMultipleSelect = (
  organization,
  setAllOrganization,
  setMultipleSelectData,
  e
) => {
  const pageRow = organization;
  let tempPage = "";
  const { checked } = e.target;
  tempPage = pageRow.map((user) => {
    return { ...user, isChecked: checked };
  });

  const selectedItems = tempPage.filter((item) => {
    return item.isChecked === true;
  });
  setMultipleSelectData(selectedItems);
  setAllOrganization(tempPage);
};

export const pageSingleSelect = (
  organization,
  setAllOrganization,
  setMultipleSelectData,
  e
) => {
  const pageRow = organization;
  const { name, checked } = e.target;
  const tempPage = pageRow.map((user) => {
    return user.id.toString() === name ? { ...user, isChecked: checked } : user;
  });
  const seleteditem = tempPage.filter((item) => item.isChecked === true);
  setMultipleSelectData(seleteditem);
  setAllOrganization(tempPage);
};
